import { useEffect, useState } from "react";
import { Asterisk } from "lucide-react";
import api from "@/lib/api";

const DEFAULTS = {
  main_message: "Produits fabriqués, vendus et livrés depuis la France",
  main_enabled: true,
  promo_message: "",
  promo_enabled: false,
};

const Row = ({ message, textClass, iconClass }) => (
  <div className="flex shrink-0 items-center">
    {[...Array(6)].map((_, i) => (
      <span key={i} className="flex items-center">
        <span className={`mx-6 whitespace-nowrap text-[11px] font-bold uppercase tracking-[0.22em] ${textClass}`}>
          {message}
        </span>
        <Asterisk className={`h-4 w-4 shrink-0 ${iconClass}`} />
      </span>
    ))}
  </div>
);

const TopBanner = () => {
  const [settings, setSettings] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("sk_banner")) || DEFAULTS;
    } catch {
      return DEFAULTS;
    }
  });

  useEffect(() => {
    api
      .get("/settings/banner")
      .then((r) => {
        setSettings(r.data);
        localStorage.setItem("sk_banner", JSON.stringify(r.data));
      })
      .catch(() => {});
  }, []);

  const showPromo = settings.promo_enabled && settings.promo_message.trim();
  const showMain = settings.main_enabled && settings.main_message.trim();
  if (!showPromo && !showMain) return null;

  return (
    <div data-testid="top-banner">
      {showPromo && (
        <div data-testid="top-banner-promo" className="overflow-hidden bg-terracotta py-2">
          <div className="flex w-max animate-marquee">
            <Row message={settings.promo_message} textClass="text-sand" iconClass="text-ochre" />
            <Row message={settings.promo_message} textClass="text-sand" iconClass="text-ochre" />
          </div>
        </div>
      )}
      {showMain && (
        <div data-testid="top-banner-main" className="overflow-hidden border-b border-bark/10 bg-ochre py-2.5">
          <div className="flex w-max animate-marquee">
            <Row message={settings.main_message} textClass="text-bark" iconClass="text-bark/70" />
            <Row message={settings.main_message} textClass="text-bark" iconClass="text-bark/70" />
          </div>
        </div>
      )}
    </div>
  );
};

export default TopBanner;
